<template>
  <div class="scope-items-cell">
    <div class="scope-items" v-if="scopeItems && scopeItems.length">
      Required scope items:
      <bdg-simple-list :items="scopeItems" />
    </div>
    <div class="change-orders" v-if="changeOrders && changeOrders.length">
      Required change orders:
      <bdg-simple-list :items="changeOrders" />
    </div>
    <div class="design-sheets" v-if="designSheets && designSheets.length">
      Required design sheets:
      <bdg-simple-list :items="designSheets" />
    </div>
    <div
      class="additional-services mt-5"
      v-if="additionalServices && additionalServices.length"
    >
      Additional services:
      <bdg-simple-list :items="additionalServices" />
    </div>
  </div>
</template>

<script>
import BdgSimpleList from "../../simple-list/BdgSimpleList";

export default {
  name: "ScopeItemsCell",
  components: { BdgSimpleList },
  props: {
    scopeItems: Array,
    changeOrders: Array,
    designSheets: Array,
    additionalServices: Array
  }
};
</script>

<style scoped></style>
